import { useState, useMemo } from "react";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import SurveyService from "../Services/SurveyService";
import QuestionModel from "../Models/Survey/Questions/QuestionModel";
import PossibleAnswerModel from "../Models/Survey/Questions/PossibleAnswerModel";
import { useTranslation } from "react-i18next";

export default function MultipleChoiceAnswers(props: {
  questionModel: QuestionModel, surveyId: string,
  setQuestionModel: Function, setIsFirstQuestion: Function, setCurrentQuestionId: Function, setLoading: Function
}) {
  const { t, i18n } = useTranslation("survey");

  const surveyService = useMemo(() => new SurveyService(), []);

  if (props.questionModel !== undefined && props.questionModel.possibleAnswers?.length > 0) {

    const mapped = props.questionModel.possibleAnswers
      .sort((a, b) => a.sequence - b.sequence)
      .map((model: PossibleAnswerModel, index: number) => {
        return (
          <Button
            className="m-2"
            variant={model.selected === true ? "contained" : "outlined"}
            key={model.id ?? `fallback-${index}`}
            style={{
              textTransform: "none",
              maxWidth: "100%",
            }}
            onClick={() => clickAnswer(model)}
          >
            {model.translatedAnswer ?? model.answer}
          </Button>
        );
      });

    return (
      <div>
        {mapped}

        {props.questionModel.imageBase64String && (
          <img
            src={`data:${props.questionModel.imageType};base64,${props.questionModel.imageBase64String}`}
            alt="Vraag afbeelding"
            style={{
              marginTop: '1rem',
              width: 'auto',
              height: '350px',
              display: 'block',
            }}
          />
        )}
      </div>
    );

  }

  return (
    <></>
  )


  function clickAnswer(answer: PossibleAnswerModel) {
    if (props.questionModel) {
      props.setLoading(true);

      surveyService
        .saveMultipleChoiceAnswer(
          {
            surveyId: props.surveyId,
            nextQuestionId: answer.nextQuestionId,
            possibleAnswerId: answer.id,
            questionId: props.questionModel.id,
            answer: answer.answer,
          },
          i18n.language
        )
        .then((result) => {
          if (result) {
            if (result.success) {
              //do stuff with question
              if (result.nextQuestionModel !== null) {
                //set Progress bar
                props.setQuestionModel(result.nextQuestionModel);
                props.setIsFirstQuestion(
                  result.nextQuestionModel.thisIsTheFirstQuestion
                );
                props.setCurrentQuestionId(result.nextQuestionModel.id);
              }
            } else {
              toast.error(t("Fout bij opslaan van vraag."));
            }
          }
          props.setLoading(false);
        });
    }
  }
}